import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SriyanshCardHeader from "../../components/CardHeader";
import ExportToPDFCustomButton from "../../components/ExportPDFfromTable.js";
import apiClient from "../../BaseUrl/apiClient.js"
import {DISPLAY_PAGE_SIZE} from "../../constants/constants"
import "../../css/App.css";
import "../../css/color.css";
import _ from "lodash";
import TokenService from "../../service/TokenService";
import CircularProgress from "@mui/material/CircularProgress";
import ExportToExcelCustomButton from "../../components/ExportToExcelButtonCustom";

import SearchTextField from "../../CustomComponant/SearchTextField";
import ListDynamicTable from "../../CustomComponant/ListDynamicTable";

function SuitabilityPendingList() {
  const [pageLoader, setPageLoader] = useState(false);
  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [srcinddata, setSrcinddata] = useState("");
  const [reportData, setReportData] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;

  
  const [gatepass, setgatepass] = useState("");

  // Debounced search function
  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      try {
        //setPageLoader(true);
        const response = await apiClient.post("/getsuitabilitypendingList", {
          uname: uname,
          limit: String(pageSize * (currentPage - 1)),
          offset: String(pageSize),
          srcinddata: searchTerm,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);
        
        setgatepass(response.data[0].getpassnumber);
        const allDataResponse = await apiClient.post("/getsuitabilitypendingList", {
          uname: uname,
          limit: "0", // No limit
          offset: "0", // No offset
          srcinddata: "", // No search term for fetching all data
        });

        setReportData(allDataResponse.data);
      } catch (error) {
        setReturnData([]);
        setTotalRows(0);
      }finally
      {
        setPageLoader(false);
      }
    }, 300),
    [currentPage, pageSize]
  );

  useEffect(() => {
    fetchData(srcinddata);
    // eslint-disable-next-line
  }, [srcinddata, fetchData]);

  ///////HANDLE ROW CLICK start////////////////

  const handleRowClick = (row) => {
    viewData(row.entrynumber, row.getpassnumber);
  };

  const viewData = (po, pass) => {
    navigate("suitabilityentry", {
      state: {
        exppo: po,
        expgatepass: pass,
      },
    });
  };

  ///////HANDLE ROW CLICK END////////////////

  const columns = [
    "Shop",
    "ponumber",
    //"podate",
    "getpassnumber",
    
    "itemReceivedDate",
    "daydiff",
    //"DPdate",
    "poitemname",
    "pushdate",
    "reason",
  ]; // keys from your data objects
  const columnNames = [
    "Consignee",
    "PO Number",
    //"PO Date",
    "Gate Entry/Memo Number",
     "Item Receiving Date",
    "Pending Days from Item Received",
    //"DP Date",
    "Item Name                      ",
    "Item Push Date",
    "Unsuitability Reason",
  ];

  return (
    <div >
      {/* <SriyanshCardHeader Title="Suitability Pending List" /> */}

      <Card className="Formcard">

      <div className="input-groupHeading">
      Suitability Pending List

            </div>

        <CardContent>
          {/*-----------------------SEARCH BOX--------------------*/}
          {currentPage === 1 ? (
            <SearchTextField
              label="PO Number"
              value={srcinddata}
              title="Enter PO Number"
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search PO">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}

          {/* ------------------------------LIST of Data ----------------------------*/}

          {pageLoader ? (
            <div className="loaderContainer">
              {" "}
              <CircularProgress />{" "}
            </div>
          ) : (
            <ListDynamicTable
              columns={columns}
              columnNames={columnNames}
              data={returnData}
              totalRows={totalRows}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              onRowClick={handleRowClick}
            />
          )}

          <div className="mb-3 container mt-2 col-12 gap-4 d-flex justify-content-center">
            <ExportToExcelCustomButton
              data={reportData}
              fileName={"Suitability"} // + `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to Excel"
            />

            <ExportToPDFCustomButton
              data={reportData}
              fileName={"Suitability"}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to PDF"
              pageHeader="Suitability Pending List"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default SuitabilityPendingList;
